import { ReactComponent as FlagIcon } from "./svg/pt-flag.svg";
import "../flag-icon.scss";

export const PTFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
